import { AUTH_APIS } from "@/api_framework/api_config";
import { logTokenEvent } from "@/api_framework/tokenDiagnostics";
import { IIAMLoginResponse } from "@/api_framework/api_modals/IAMUser";
import { ROUTES } from "@/app/routes";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setAuthorization, setUserValid } from "@/app_redux/reducers/auth_reducer";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import { useConfiguration } from "../../useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export const useUserAuthenticationTokenAPI = () => {
  const [logStatus, setLogStatus] = useState<boolean>(false);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const navigate = useNavigate();
  const callback = useCallback(
    async (googleOAuthToken: string) => {
      try {
        axios
          .post(AUTH_APIS.IAM_LOGIN.baseURL, {
            google_id_token: googleOAuthToken,
          }, {
            withCredentials: true,
          })
          .then((res: AxiosResponse<IIAMLoginResponse>) => {
            if (res.status === 200) {
              dispatch(
                setAuthorization({
                  accessToken: `Bearer ${res.data.data.auth_token}`,
                  isValid: true,
                }),
              );
              // toastNotification(res.data.message);
              localStorage.setItem(configuration.localStorage.ACCESS_TOKEN.key, `Bearer ${res.data.data.auth_token}`);
              logTokenEvent("USER_LOGIN", { method: "google_sso" });
              logTokenEvent("ACCESS_TOKEN_ISSUED", { issued_by: "google_sso_login" });
              setLogStatus(true);
            }
          })
          .catch((e: AxiosError) => {
            setLogStatus(false);
            dispatch(setUserValid({ isValid: false }));
            dispatch(
              setAuthorization({
                isValid: false,
                accessToken: null,
              }),
            );
            captureError(e);
            navigate(ROUTES.LOGIN_PAGE.url);
          });
      } catch (e) {
        setLogStatus(false);
        dispatch(setUserValid({ isValid: false }));
        dispatch(
          setAuthorization({
            isValid: false,
            accessToken: null,
          }),
        );
        captureError(e);
        navigate(ROUTES.LOGIN_PAGE.url);
        // toast.error("Can't resolve IAM API");
      }
    },
    [dispatch],
  );
  return { logStatus, callback };
};
